/* ════════════════════════════════════════════════════════════
   PAWSY LP FUNNEL — scroll engine + per-section sticky CTA (v1)
   ------------------------------------------------------------
   • Each panel (.plf-panel) advances to the next panel via its
     CTA ([data-plf-advance]) or navigates if it carries a real href.
   • Quiz options record to dataLayer + localStorage; the final
     yes/no options carry an href so both route to the product.
   • MOBILE STICKY CTA: a single bottom bar mirrors the CURRENT
     panel's CTA. It hides the moment that panel's own inline CTA
     scrolls into view (so the sticky "lands" exactly on the real
     button), then re-appears for the next panel. Panels without a
     CTA (the quiz questions) show no sticky bar.
   Self-guards so it is safe to load once per page.
   ════════════════════════════════════════════════════════════ */
(function () {
  if (window.__plfInit) return;
  window.__plfInit = true;

  var STORE_KEY = 'plf_answers';
  var root, panels, sticky, stickyBtn, stickyLabel;
  var activePanel = null;

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ---- Advance / navigation ---- */
  function scrollToNext(fromPanel) {
    var i = panels.indexOf(fromPanel);
    var next = panels[i + 1];
    if (next) {
      next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  }

  function recordAnswer(key, value) {
    if (!value) return;
    try {
      var store = JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
      store[key || 'q'] = value;
      localStorage.setItem(STORE_KEY, JSON.stringify(store));
    } catch (e) { /* private mode / quota — non-fatal */ }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'lp_funnel_answer', question: key || 'q', answer: value });
  }

  /* Skip: jump straight to the first quiz question (panel with options). */
  function firstQuestionPanel() {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].querySelector('.plf-options')) return panels[i];
    }
    return null;
  }

  /* A click on any advancer: a CTA button, a skip button, or a quiz option. */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-plf-advance], [data-plf-skip], .plf-option');
    if (!el || !root || !root.contains(el)) return;

    var panel = el.closest('.plf-panel');

    if (el.hasAttribute('data-plf-skip')) {
      e.preventDefault();
      var q = firstQuestionPanel();
      if (q) { q.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      else { window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); }
      return;
    }

    if (el.classList.contains('plf-option')) {
      var group = el.closest('.plf-options');
      if (group) {
        $all('.plf-option', group).forEach(function (o) { o.classList.remove('is-selected'); });
      }
      el.classList.add('is-selected');
      recordAnswer(el.getAttribute('data-plf-key'), el.getAttribute('data-plf-value'));
    }

    var href = el.getAttribute('href');
    var isRealLink = el.tagName === 'A' && href && href.charAt(0) !== '#' && href.trim() !== '';
    if (isRealLink) return; // let the browser navigate (e.g. final product CTA)

    e.preventDefault();
    setTimeout(function () { scrollToNext(panel); }, el.classList.contains('plf-option') ? 140 : 0);
  });

  /* ---- Sticky CTA: mirror the active panel, hide when its CTA shows ---- */
  function panelCta(panel) {
    return panel ? panel.querySelector('.plf-cta') : null;
  }

  function isInView(elm) {
    if (!elm) return false;
    var r = elm.getBoundingClientRect();
    // "Visible" = it has entered from the bottom of the viewport. The instant
    // the real CTA crosses up into view, the sticky bar gives way to it.
    return r.top < (window.innerHeight - 8) && r.bottom > 0;
  }

  function currentPanel() {
    var mid = window.innerHeight * 0.5;
    var chosen = panels[0] || null;
    for (var i = 0; i < panels.length; i++) {
      var r = panels[i].getBoundingClientRect();
      if (r.top <= mid && r.bottom > mid) return panels[i];
      if (r.top <= mid) chosen = panels[i];
    }
    return chosen;
  }

  function syncSticky() {
    if (!sticky) return;
    var panel = currentPanel();
    activePanel = panel;
    var cta = panelCta(panel);

    // No CTA on this panel (quiz questions), or the real CTA is on screen → hide.
    if (!cta || isInView(cta)) {
      sticky.classList.remove('is-visible');
      return;
    }
    stickyLabel.textContent = panel.getAttribute('data-plf-sticky-label') || cta.textContent.trim();
    sticky.classList.add('is-visible');
  }

  // Sticky button replays the active panel's CTA action.
  function onStickyClick(e) {
    if (!activePanel) return;
    var cta = panelCta(activePanel);
    if (!cta) return;
    var href = cta.getAttribute('href');
    if (cta.tagName === 'A' && href && href.charAt(0) !== '#' && href.trim() !== '') {
      window.location.href = href;
    } else {
      e.preventDefault();
      scrollToNext(activePanel);
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { syncSticky(); ticking = false; });
  }

  function init() {
    root = document.querySelector('.plf');
    if (!root) return;
    panels = $all('.plf-panel', root);
    sticky = root.querySelector('.plf-sticky');
    if (sticky) {
      stickyBtn = sticky.querySelector('.plf-sticky-btn');
      stickyLabel = sticky.querySelector('.plf-sticky-label');
      if (stickyBtn && !stickyBtn.__wired) {
        stickyBtn.__wired = true;
        stickyBtn.addEventListener('click', onStickyClick);
      }
    }
    syncSticky();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: re-bind when the section is re-rendered.
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:section:reorder', function () { setTimeout(init, 60); });
})();
